import React, { memo, useEffect, useState } from 'react'
import { array, number, string } from 'prop-types'
import styled from 'styled-components'
import { withRouter } from 'next/router'

import { useModuleContext } from '../../contexts/EventsContext'
import usePush from '../../hooks/usePush'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import { Dropdown, Row } from '@mch-group/uikit-components'

const Locations = memo(
  ({
    //@ts-ignore
    locationsData,
    //@ts-ignore
    rows = 5,
    //@ts-ignore
    columns = 6
  }) => {
    //@ts-ignore
    const [{ router, labels, CMSProps }] = useModuleContext()
    const routerQuery = router.query
    const cityId = routerQuery?.cityId && routerQuery.cityId.split(',') || []
    const { pushChange } = usePush()
    const selectedLocations = cityId
    const [locations, setLocations] = useState<any>({
      all: null,
      list: null,
      menu: null
    })

    useEffect(() => {
      if (locationsData) {
        const listLength = rows * columns - 2
        const selectedLocation = CMSProps.evg_grp1_city?.split(',')
        const result = selectedLocation?.length > 0
          ? locationsData.filter(data => selectedLocation.includes(data.code))
          : locationsData
        // console.log('result', locationsData)
        setLocations({
          all: result,
          list: result.slice(0, listLength),
          menu: result.slice(listLength, result?.length).sort(
            (a, b) => a.value > b.value || (a.value < b.value ? -1 : 0)
          )
        })
      }
    }, [locationsData, rows, columns, CMSProps.evg_grp1_city])

    if (!labels) return null

    return locations.all ? (
      <StyledWrapper className='mb-3'>
        <div className='fw-bold'>{labels.Events.browseFilterLocation}</div>
        <Row md={5}>
          <Dropdown
            variant='multiple'
            options={locations.all.map((city) => ({ key: city.value, label: `${city.value} (${city.count})`, value: city.code }))}
            label={selectedLocations?.length > 0 ? `${selectedLocations?.length} ${labels.Events.browseFilterAll}` :
              labels.Events.browseFilterAll}

            onChange={(value) => {
              const currentSelection = routerQuery.cityId ? routerQuery.cityId.split(',') : []
              const isCurrentSelectionAlreadySelected = currentSelection.find((option) =>
                // @ts-ignore
                value.join() === option)
              const filteredAry = isCurrentSelectionAlreadySelected ?
                // @ts-ignore
                currentSelection.filter(e => e !== value.join())
                : value
              pushChange(filteredAry.join(), 'cityId')
            }}
            value={selectedLocations}
          />
        </Row>
      </StyledWrapper>
    ) : null
  }
)

Locations.displayName = 'Locations'

//@ts-ignore
Locations.propTypes = {
  // TODO CLEAN UNNECESSARY
  locationsData: array,
  title: string,
  rows: number,
  columns: number,
  allLabel: string,
  moreLocationsLabel: string,
  selectedNumberLabel: string
}

const StyledWrapper = styled.div`
  h5 {
    font-size: ${tokens.fontSize[1].value};

    @media (max-width: 992px) {
      margin-bottom: 0;
    }
  }

  section {
    @media (max-width: 992px) {
      display: none;
    }
  }

  > .multiple.selection.dropdown {
    display: none;
    padding: 10px 0;
    border-bottom: 1px solid ${tokens.color.light.base.neutrals['300'].value} !important;

    @media (max-width: 992px) {
      display: flex;
    }
  }
`

export default withRouter(Locations)
